//****************************************************************************//
//                         DELIVERY OPTION SERVICE                           //
//****************************************************************************//

/*ALL THE NETWORK CALLS MADE TO UPDATE OR RETRIEVE DELIVERY INFORMATION SHOULD GO HERE*/

import { NETWORK_URLS } from '../constants/NetworkConstants';
import { apiUrl, headerHelper } from '../helper/Utility'

export default class ZoneService {
  static getZoneByLocation = async (coordinates, token) => {
    var endpoint = NETWORK_URLS.get_zone_by_lat_lng.replace('latcode', coordinates.lat).replace('lngcode', coordinates.lng);

    try {
      const response = await fetch(
        `${apiUrl()}${endpoint}`, {
        method: 'GET',
        headers: headerHelper(token),
      }
      );
      const json = await response.json();
      return json;
    }

    catch {
      console.log("error");
      return [];
    }
  }
}